import * as React from "react";
import { cn } from "@/lib/utils";

export type ShinyTextProps = {
  text: string;
  className?: string;
  dy?: number;
};

export function ShinyText({ text, className, dy = 3 }: ShinyTextProps) {
  const characterEntries = React.useMemo(() => {
    const counts: Record<string, number> = {};

    return Array.from(text).map((character) => {
      const keyBase = character === " " ? "space" : character;
      counts[keyBase] = (counts[keyBase] ?? 0) + 1;

      return { character, key: `${keyBase}-${counts[keyBase]}` };
    });
  }, [text]);

  return (
    <span className="relative mx-auto">
      {characterEntries.map(({ character, key }) => {
        const displayCharacter = character === " " ? "\u00A0" : character;

        return (
          <span key={key} className={cn("shiny-text inline-block", className)}>
            <span className="shiny-text-text shine">{displayCharacter}</span>
            <svg
              className="shiny-text-svg"
              aria-hidden="true"
              focusable="false"
            >
              <text
                className="shiny-text-svg-text--depth"
                x="0"
                y="0"
                textAnchor="start"
                dominantBaseline="text-before-edge"
                alignmentBaseline="text-before-edge"
                vectorEffect="non-scaling-stroke"
                dy={dy}
                xmlSpace="preserve"
              >
                {displayCharacter}
              </text>
              <text
                className="shiny-text-svg-text--outline"
                x="0"
                y="0.5"
                textAnchor="start"
                dominantBaseline="text-before-edge"
                alignmentBaseline="text-before-edge"
                vectorEffect="non-scaling-stroke"
                xmlSpace="preserve"
              >
                {displayCharacter}
              </text>
            </svg>
          </span>
        );
      })}
    </span>
  );
}
